import React from 'react';
import PropTypes from 'prop-types';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import { useNode } from '@splashthat/splash-cms-engine';
import { BRAND_LIBRARY_LIGHT_TEXT_COLOR, BRAND_LIBRARY_SUBHEADLINE_TEXT } from 'common/constants/brandLibrary';
import { getCustomCssClassName } from 'common/components/TouchpointEditor/tools/CustomCssTools/CustomCssTools';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';
import { formatEventDate } from './utils';
import { DateContent } from './Date.styles';

const bootstrap = getBootstrap();

const startTime = bootstrap.get('event.startTime');
const endTime = bootstrap.get('event.endTime');
const { formattedStart, formattedEnd } = formatEventDate(startTime, endTime);
const BASE_CLASS_NAME = 'Date';

export default function Date({ styles: { fontFamily, fontSize, fontColor }, selected, hovered }) {
    const node = useNode();
    const { theme } = useTouchpointData();
    const customCssClassName = getCustomCssClassName(node);

    return (
        <DateContent
            selected={selected}
            hovered={hovered}
            onMouseLeave={node.actions.onMouseLeave()}
            onMouseMove={node.actions.onMouseMove()}
            data-qa={`${BASE_CLASS_NAME}--element`}
            onClick={node.actions.onClick()}
            $fontFamily={theme.activeFonts[fontFamily]}
            $fontSize={fontSize}
            $fontColor={theme.colors[fontColor]}
            className={customCssClassName}
        >
            <time dateTime={startTime}>{formattedStart}</time>
            {!!formattedEnd && (
                <React.Fragment>
                    <span>-</span>
                    <time dateTime={endTime}>{formattedEnd}</time>
                </React.Fragment>
            )}
        </DateContent>
    );
}

Date.splash = {
    related: {
        settings: React.lazy(() => import('./Date.tools')),
    },
    defaultProps: {
        styles: {
            fontFamily: BRAND_LIBRARY_SUBHEADLINE_TEXT,
            fontSize: 20,
            fontColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
        },
    },
};

Date.propTypes = {
    styles: PropTypes.shape({
        fontFamily: PropTypes.number,
        fontSize: PropTypes.number,
        fontColor: PropTypes.number,
    }).isRequired,
    selected: PropTypes.bool.isRequired,
    hovered: PropTypes.bool.isRequired,
};
